const axios = require('axios').default;
const RESOURCE_NAME = process.env.REACT_APP_API_BASE + '/curricula';

const getHeader = (token) => {
    if (!token) {
        token = localStorage.getItem("accessToken");
    }
    return {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
};

export default {
    getCourseInfo(token) {
        const requestOptions = {
            headers: getHeader(token),
        };
        return axios.get(RESOURCE_NAME, requestOptions);
    },

    getLessonInfo(currCode, token) {
        const requestOptions = {
            headers: getHeader(token),
        };
        return axios.get(`${RESOURCE_NAME}/${currCode}/lessons`, requestOptions);
    },
}
